// extracted by mini-css-extract-plugin
export default {"menuContainer":"CotejoCriteriosPage_menuContainer__WOjfN","menuOption":"CotejoCriteriosPage_menuOption__a6Cpq","selected":"CotejoCriteriosPage_selected__VhH-r"};